import { render, staticRenderFns } from "./TimeDimensionsTab.vue?vue&type=template&id=26ea69a0&"
import script from "./TimeDimensionsTab.vue?vue&type=script&lang=js&"
export * from "./TimeDimensionsTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports